//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const formatNumber = (num) => num > 9 ? num : `0${num}`
const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step))
export default {
    data () {
        const date = new Date()
        return {
            show_list: false,
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDay(),
        }
    },
    props: {
        value: [String, Number],
        start: [String, Number],
        end: [String, Number],
        fields: String
    },
    watch: {
        value: {
            handler (val, old) {
                if (val != old) {
                    const vals = val.split('-')
                    console.log(vals)
                    if (this.fields === 'year') {
                        this.year = Number(vals && vals.length ? vals[0] : '')
                    }
                    if (this.fields === 'month') {
                        this.year = Number(vals && vals.length ? vals[0] : '')
                        this.month = Number(vals && vals.length > 1 ? vals[1] : '')
                    }
                    if (this.fields === 'day') {
                        this.year = Number(vals && vals.length ? vals[0] : '')
                        this.month = Number(vals && vals.length > 1 ? vals[1] : '')
                        this.day = Number(vals && vals.length > 2 ? vals[2] : '')
                    }
                    this.$nextTick(this.moveScroll)
                }
            },
            immediate: true
        }
    },
    computed: {
        show_month_list () {
            return this.fields !== 'year'
        },
        show_day_list () {
            return this.fields === 'day'
        },
        year_list () {
            const list = []
            for (let i = 0; i < this.end - this.start; i++) {
                list.push(this.start + i)
            }
            return list
        },
        month_list () {
           return range(1, 12, 1)
        },
        day_list () {
        }
    },
    methods: {
        moveScroll () {
            if (this.$el && typeof this.$el.querySelector === 'function') {
                const $active_els = this.$el.querySelectorAll('.active')
                if ($active_els && $active_els.length) {
                    $active_els.forEach(($item) => {
                        $item.scrollIntoView()
                    })
                }
            }
        },
        changeDate () {
            const arr = [this.year]
            if (this.fields === 'month' || this.fields === 'day') {
                arr.push(this.month)
            }
            if (this.fields === 'day') {
                arr.push(this.day)
            }
            this.$emit('change', {
                target: {
                    value: arr.map(a => formatNumber(a)).join('-')
                }
            })
        },
        selectYear (i) {
            this.year = this.year_list[i]
            this.changeDate()
        },
        selectMonth (i) {
            this.month = this.month_list[i]
            this.changeDate()
        },
        selectDay (i) {
            this.day = this.day_list[i]
            this.changeDate()
        },
        toggleList () {
            this.show_list = !this.show_list
        }
    }
}
